export const sanitizeString = (str: string) => {
    str = str.replace(/\s+/g, '_');
    return str.trim();
};

export const capitalize = (str: string) => str && str[0].toUpperCase() + str.slice(1);
